import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  Button,
  Chip,
  Container
} from "@mui/material";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";

import wildlingsCelebration1 from '../../../images/wildlings-celebration-national-league-ai-enhanced.png'
import wildlingsCelebration2 from '../../../images/wildlings_celebration_nationals.png'


export default function Header() {
  return (
        <Box
            sx={{
                pt: {xs: '70px', sm: '100px', xl: '200px'},
                pb: {xs: '100px', xl: '200px'},
                color: "#e9eef6",
                backgroundImage: {
                    xs: `linear-gradient(120deg, rgba(0, 0, 49, 0.75) 0%, rgba(255, 0, 0, 0.5) 100%), url(${wildlingsCelebration1})`,
                    sm: `linear-gradient(120deg, rgba(0, 0, 49, 0.75) 0%, rgba(255, 0, 0, 0.4) 100%), url(${wildlingsCelebration2})`
                },
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: 'center 65px'
            }}
        >

          <Container sx={{ position: "relative", zIndex: 1 }}>
            <Stack spacing={3} maxWidth={880} sx={{mt: 8}}>
              <Chip
                icon={<SportsSoccerIcon />}
                color="secondary"
                label="About Atlantic United Soccer Club"
                sx={{ display: {xs: 'none', sm: 'inherit'}, bgcolor: "transparent", color: "white", fontWeight: 800, border: "1px solid white", padding: '20px' }}
              />
              <Typography variant="h2" component="h1" gutterBottom sx={{fontSize: {xs: "32px", sm: "40px", lg: "60px"}}}>
                History of Success. <br/>Proven Development.
              </Typography>
              <Typography variant="h6" sx={{ opacity: 0.95, lineHeight: 1.6 }}>
                Atlantic United Soccer Club prides itself in developing elite athletes and teams while providing a pathway for all players.
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <Button sx={{transition: "opacity 0.3s, transform 0.3s", "&:hover": { opacity: 0.85, transform: "scale(1.05)" },}} component={Link} to="/programs" size="large" variant="contained" color="secondary">
                  Our Programs
                </Button>
                <Button sx={{transition: "opacity 0.3s, transform 0.3s", "&:hover": { opacity: 0.85, transform: "scale(1.05)" },}} href="#pictures-and-text-2" size="large" variant="outlined" color="inherit">
                  Learn More
                </Button>
              </Stack>
            </Stack>
          </Container>
        </Box>
  );
}
